"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  EMAIL: 2,
  LANDING_PAGE: 4,
  BLOG_POST: 6,
  BLOG_LISTING: 7,
  ERROR_PAGE: 11,
  SUBSCRIPTION_PREFERENCES: 12,
  UNSUBSCRIBE_CONFIRMATION: 13,
  UNSUBSCRIBE_SIMPLE: 14,
  PASSWORD_PAGE: 19,
  STYLESHEET: 24,
  SEARCH_RESULTS: 27,
  MEMBERSHIP_LOGIN: 29,
  MEMBERSHIP_REGISTER: 30,
  MEMBERSHIP_RESET: 31,
  MEMBERSHIP_RESET_REQUEST: 32,
  DRAG_DROP_EMAIL: 34,
  MEMBERSHIP_EMAIL: 36,
  DEFAULT_TEMPLATE: 'default'
};
exports.default = _default;
module.exports = exports.default;